import { api } from "../api/callApi";
import { urlServer } from "../api/v1";
import { ICapability, IServiceTask } from "../varibles/interface";

const urlBase = urlServer + '/capability';

export const CapabilityService = {
    serviceTasks: () => {
        return api.get<IServiceTask[]>(urlBase + '/tasks')
    },
    createServiceTask: (data: IServiceTask) => {
        return api.post<IServiceTask>(urlBase + '/task', data)
    },
    updateServiceTask: (data: IServiceTask) => {
        return api.put<IServiceTask>(urlBase + '/task', data)
    },
    deleteServiceTask: (id: string) => {
        return api.deleteBody(urlBase + '/task', { id })
    },
    gets: () => {
        return api.get<ICapability[]>(urlBase + '/s')
    }
}